import { render, staticRenderFns } from "./SummaryStudyData.vue?vue&type=template&id=0680bde9&scoped=true"
import script from "./SummaryStudyData.vue?vue&type=script&lang=ts"
export * from "./SummaryStudyData.vue?vue&type=script&lang=ts"
import style0 from "./SummaryStudyData.vue?vue&type=style&index=0&id=0680bde9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0680bde9",
  null
  
)

export default component.exports